import React, { Fragment, PureComponent } from "react";

import Tabla from "../../../components/UI/tabla/tablaSort";
import Editor from './Editor.jsx'
import { Notificacion } from "../../../components/Util/Notificacion/Notificacion";

class ColoresItfz extends PureComponent {
  state = {
    columnasColores: [
      {
        dataField: "Color_Id",
        text: "Id",
        hidden: false,
        sort: true,
        editable: false,
        align: "left",
        isKey: true,
        tabIndex: 1
      },
      {
        dataField: "Nombre",
        text: "Nombre",
        tabIndex: 2,
        hidden: false,
        sort: true,
        validator: (newValue, row, column) => {
          if (newValue.length === 0 || newValue.length > 35) {
            Notificacion.error('Dede ingresar un dato válido, entre 1 y 35 caracteres');
            return { valid: false };
          }
          return true;
        },
        editorRenderer: (
          editorProps,
          value,
          row,
          column,
          rowIndex,
          columnIndex
        ) => <Editor {...editorProps} value={value} />,
        formatter: (cellContent, row) => (
          <div>
            <input
              className="btn btn-form text-left react-table-input col"
              tabIndex="-1"
              onChange={() => { }}
              type="text"
              maxLength="35"
              minLength="1"
              value={row.Nombre}
            ></input>
          </div>
        )
      }
    ],
    cellEdit: {},
    selectRow: {
      onSelect: this.props.onRowSelect,
      hideSelectColumn: true,
      mode: "checkbox",
      style: { background: "#e2f3f9" },
      clickToSelect: true,
      clickToEdit: true
    },
    rowStyle: {},
    keyField: "Color_Id"
  }

  render() {
    const { Datos, listaColores, paginaActual, onPageChange, onSizePerPageChange } = this.props;

    const { columnasColores, keyField, rowStyle, selectRow } = this.state;

    const rowClasses = (row, rowIndex) => {
      let classes = null;
      if (listaColores.length > 0 && listaColores[0].Color_Id === 0 && rowIndex === 0) {
        classes = "abierta";
      }

      return classes;
    };

    const cellEdit = {
      mode: "click",
      blurToSave: true,
      autoSelectText: true,
      afterSaveCell: (oldValue, newValue, row, column) => {
        newValue !== oldValue && this.props.ingresarDatos(oldValue, newValue, row, column);
      }
    };

    return (
      <Fragment>
        <div className="container mt-3">
          <div className="row">
            <div className="col-12">
              <h1>{Datos.titulo}</h1>
            </div>
          </div>
        </div>
        <div className="container">
          <Tabla
            columnas={columnasColores}
            datos={listaColores}
            keyField={keyField}
            modo={cellEdit}
            rowStyle={rowStyle}
            rowClasses={rowClasses}
            selectRow={selectRow}
            handleNuevo={this.props.ingresarFila}
            handleBorrar={this.props.handleBorrar}
            paginaActual={paginaActual}
            onPageChange={onPageChange}
            onSizePerPageChange={onSizePerPageChange}
          />
        </div>
      </Fragment>
    );
  }
}

export default ColoresItfz;
